import {z} from 'zod';
import {Uuid,IsoDateTime,success} from '@secretaa/http-contract';
import {FieldType,FieldConfig,I18nLabel} from './dynamic-data.ts';
import {Ref} from './work-os/primitives.ts';
const hash=z.string().regex(/^[a-f0-9]{64}$/);
export const InspectRecordActionBody=z.object({operation:z.enum(['CREATE','UPDATE']),manifestHash:hash}).strict();
/** Native descriptors are derived by Data from an immutable Blueprint version, never supplied by the browser. */
export const RecordActionDescriptor=z.object({
 nativeContractVersion:z.literal(1),kind:z.literal('RECORD_MUTATION'),
 scope:z.object({workspaceId:Uuid,projectId:Uuid}).strict(),collectionId:Uuid,operation:z.enum(['CREATE','UPDATE']),
 ref:Ref,sourceRef:Ref,inputContractRef:Ref,targetConstraintRef:Ref,confirmationPolicyRef:Ref,
 blueprintManifestRef:Ref,manifestHash:hash,
 fields:z.array(z.object({id:Uuid,label:I18nLabel,type:FieldType,required:z.boolean(),indexed:z.boolean(),config:FieldConfig}).strict()).min(1).max(100),
 target:z.object({scopeRule:z.literal('CURRENT_GRANT'),versionRule:z.enum(['NONE','EXPECTED_VERSION'])}).strict(),
 confirmation:z.literal('EXPLICIT_USER'),
}).strict().superRefine((d,ctx)=>{
 if(new Set(d.fields.map(f=>f.id)).size!==d.fields.length)ctx.addIssue({code:'custom',message:'DUPLICATE_FIELD'});
 if(d.target.versionRule!==(d.operation==='CREATE'?'NONE':'EXPECTED_VERSION'))ctx.addIssue({code:'custom',message:'VERSION_RULE_MISMATCH'});
 const refs=[d.ref,d.sourceRef,d.inputContractRef,d.targetConstraintRef,d.confirmationPolicyRef];
 if(new Set(refs.map(r=>r.id)).size!==refs.length||refs.some(r=>r.version!==d.blueprintManifestRef.version))ctx.addIssue({code:'custom',message:'DESCRIPTOR_IDENTITY_MISMATCH'});
});
export const RecordActionMetadata=z.object({descriptor:RecordActionDescriptor,digest:hash,subjectId:Uuid,accessScopeVersion:z.number().int().positive(),checkedAt:IsoDateTime,expiresAt:IsoDateTime}).strict().superRefine((m,ctx)=>{
 const duration=Date.parse(m.expiresAt)-Date.parse(m.checkedAt);if(duration<=0||duration>5000)ctx.addIssue({code:'custom',message:'INVALID_METADATA_EXPIRY'});
});
export const RecordActionMetadataResponse=success(RecordActionMetadata);
export type RecordActionDescriptor=z.infer<typeof RecordActionDescriptor>;

export const ResolveRecordActionBody=z.object({referenceKind:z.enum(['ACTION','FORM_SOURCE']),ref:Ref}).strict();
